'use client';

import { logger } from '@lichtblick/logger';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { TextCTA } from '@lichtblick/photon/atoms/text-cta/text-cta';
import { startTransition, useEffect } from 'react';

import { FormHead } from './form-head/form-head';

type ErrorPageProps = { error: Error & { digest?: string }; reset: () => void };

export const ErrorPage: React.FC<ErrorPageProps> = ({ error, reset }) => {
  useEffect(() => {
    logger.error(`Uncaught Error in checkout`, {}, error);
  }, [error]);

  const reload = () => {
    startTransition(() => {
      window.location.reload();
    });
  };

  return (
    <FormHead>
      <Headline align="center" renderAs="h1">
        Ein unbekannter Fehler ist aufgetreten
      </Headline>
      <Text></Text>
      {/* Next won't be able to recover from a Chunk Load Error – just reload */}
      <BoxCTA as="button" onClick={error.name === 'ChunkLoadError' ? reload : reset}>
        Erneut versuchen
      </BoxCTA>
      <TextCTA as="a" href="/" slim>
        Zurück zur Homepage
      </TextCTA>
    </FormHead>
  );
};
